import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/smsconfiguration'
import pathMap from 'src/paths/pathMap'

class SmsConfigurationRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SMS_CONFIGURATION_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SMS_CONFIGURATION_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SMS_CONFIGURATION_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SMS_CONFIGURATION_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default SmsConfigurationRoute
